import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const backblazeB2 = defineConnector({
  identifier: "backblazeB2",
  name: "Backblaze B2",
  tagLine: "Cloud object storage",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.backblazeb2\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.backblazeb2.com/b2api/v2/b2_authorize_account",
        basicAuth: {
          username: app.config.keyId,
          password: app.secret.applicationKey,
        },
      },
      extract: { from: "jsonPath", paths: ["authorizationToken"] },
      apply: { kind: "header" },
    }),
  steps: [
    {
      title: "Create an application key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Backblaze B2 console](https://secure.backblaze.com/app_keys.htm), go to **App Keys** and create a new application key. Copy the **keyID** and **applicationKey**.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Key ID",
          required: true,
          target: { kind: "configuration", field: "keyId" },
        },
        {
          kind: "input",
          label: "Application key",
          required: true,
          target: { kind: "secrets", field: "applicationKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.backblazeb2.com/b2api/v3/b2_list_buckets",
  },
});
